import styled from '@emotion/styled';

import browserBarSvg from 'assets/images/plp/browser-bar.svg';

import { ButtonWrapper } from '@zola/zola-ui/src/components/ButtonV3/ButtonV3.styles';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

export const postAuthNav3ThemeGroupBorder = `1px solid ${COLORS3.BLACK_030}`;
export const themeGroupBorder = `1px solid ${COLORS3.BLACK_030}`;

export const ThemeGroupActionsAndPrice = styled.div`
  margin-top: auto;
  min-height: 44px;
`;

export const ThemeGroupActions = styled.div`
  align-items: center;
  flex-flow: row;
  justify-content: space-between;

  display: none;

  ${ButtonWrapper} {
    width: 48%;
  }

  ${ButtonWrapper} {
    width: 48%;
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    align-items: space-between;
    flex-flow: column;
    justify-content: center;

    ${ButtonWrapper} {
      width: 100%;

      &:first-of-type {
        margin-bottom: ${SPACING.MD};
      }
    }
  }
`;

export const ThemeGroupPrice = styled.p`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.REGULAR};
  margin: ${SPACING.XXS} 0 0 0;

  display: block;
`;

export const ThemeGroupTitle = styled(LinkV2)`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
  margin: ${SPACING.S16} 0 ${SPACING.XS} 0;
  text-decoration: none !important;
  display: block;

  &:hover, &:active, &:focus {
    color: ${COLORS3.BLACK_100} !important;
    text-decoration: none !important;
  }
`;

export const BrowserBar = styled.div`
  background-image: url(${browserBarSvg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: ${SPACING.XXS};
  border-top-right-radius: ${SPACING.XXS};
  height: 12px;
  width: 100%;
`;

export const ThemePreviewLink = styled.a`
  align-items: center;
  background-position: top;
  background-size: cover;
  border-bottom-left-radius: ${SPACING.XXS};
  border-bottom-right-radius: ${SPACING.XXS};
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const ThemeGroupPreviewContainer = styled.div<{ isSinglePage?: boolean }>`
  background-color: ${COLORS3.CLOUD_100};
  border-radius: ${SPACING.XXS};
  border: 1px solid ${COLORS3.BLACK_015};
  cursor: pointer;
  margin: 0 auto;
  max-width: 100%;
  overflow: hidden;
  width: 100%;

  ${MEDIA_QUERY.MOBILE} {
    height: ${props => (props.isSinglePage ? '132px' : '220px')};
  }

  ${MEDIA_QUERY.TABLET} {
    height: ${props => (props.isSinglePage ? '180px' : '260px')};
  }

  ${MEDIA_QUERY.DESKTOP} {
    height: ${props => (props.isSinglePage ? '220px' : '320px')};
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    height: ${props => (props.isSinglePage ? '280px' : '420px')};
  }
`;

export const ThemeGroupContainer = styled.div<{ isPostAuthNav3?: boolean }>`
  border-bottom: ${({ isPostAuthNav3 }) =>
    isPostAuthNav3 ? postAuthNav3ThemeGroupBorder : themeGroupBorder};
  border-right: ${({ isPostAuthNav3 }) =>
    isPostAuthNav3 ? postAuthNav3ThemeGroupBorder : themeGroupBorder};
  padding: ${SPACING.S16} ${SPACING.S16} ${SPACING.S32} ${SPACING.S16};
  display: flex;
  flex-flow: column;

  &:hover,
  &:active,
  &:focus-visible {
    ${ThemeGroupPrice} {
      display: none !important;
    }

    ${ThemeGroupActions} {
      display: flex !important;
    }
    ${ThemeGroupPreviewContainer} {
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
    }
  }

  ${MEDIA_QUERY.MOBILE} {
    padding: ${SPACING.XS} ${SPACING.XS} ${SPACING.S16} ${SPACING.XS};
  }
`;

export const ThemeGroupList = styled.div<{ isPostAuthNav3?: boolean }>`
  border-top: ${({ isPostAuthNav3 }) =>
    isPostAuthNav3 ? postAuthNav3ThemeGroupBorder : themeGroupBorder};
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;

  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
    border-left: ${({ isPostAuthNav3 }) => (isPostAuthNav3 ? null : themeGroupBorder)};
    border-right: ${({ isPostAuthNav3 }) => (isPostAuthNav3 ? null : themeGroupBorder)};
  }

  & > [data-plpitem] {
    ${MEDIA_QUERY.MOBILE} {
      height: 480px;
      width: 50%;
      &:nth-of-type(2n) {
        border-right: none;
      }
    }

    ${MEDIA_QUERY.TABLET} {
      height: 520px;
      width: 33.33%;
      &:nth-of-type(3n) {
        border-right: none;
      }
    }

    ${MEDIA_QUERY.DESKTOP} {
      height: 520px;
      width: 25%;
      &:nth-of-type(4n) {
        border-right: none;
      }
    }

    ${MEDIA_QUERY.DESKTOP_XL} {
      height: 600px;
    }
  }
`;
